// extracted by mini-css-extract-plugin
module.exports = {"item":"Competition_style_item__D8kE3","text":"Competition_style_text__1c9h5","title":"Competition_style_title__2Cg7W"};